import { Descendant } from 'slate';
import parseMarkdownToSlate from '@sdk/components/richText/helpers/parseMarkdownToSlate';

import { ParagraphElement } from '@web/richText/types';

export function getEmptyParagraph(): ParagraphElement {
  return { type: 'paragraph', children: [{ text: '' }] };
}

export function getEmptyValue(): Descendant[] {
  return [getEmptyParagraph()];
}

export function getInitialValue(value: string | Descendant[]): Descendant[] {
  if (!value) {
    return getEmptyValue();
  }

  if (typeof value === 'string') {
    return parseMarkdownToSlate(value);
  }

  return value;
}
